import { LitElement, html } from 'lit';
import { customElement, state } from 'lit/decorators';

import { MapSetUpOptions } from '../types';
import { StateController } from '../helpers/state/state-management/state-controller';
import accountInfo from '../helpers/state/account-info';
import { getMainPage } from '../helpers/page-name';
import { getQueryStringParameters } from '../helpers/urls';
import { isDefined } from '../helpers/utils';
import pointCache from '../helpers/state/point-cache';
import topicData from '../helpers/state/topic-data';

@customElement('map-page')
export class MapPage extends LitElement {
    amplitude_callsite: string = 'Map Page';

    @state()
    mapSetUpOptions?: MapSetUpOptions;

    private readonly bindPointCacheState = new StateController(this, pointCache);
    private readonly bindTopicState = new StateController(this, topicData);
    private readonly bindAccountState = new StateController(this, accountInfo);

    async firstUpdated() {
        await this.startup();
    }

    private async startup() {
        const queryString = getQueryStringParameters();

        const categories_array: string[] =
            queryString
                .get('categories')
                ?.split(',')
                .map((category) => category.toLowerCase()) ?? [];
        const tags_array: string[] =
            queryString
                .get('tags')
                ?.split(',')
                .map((tag) => tag.toLowerCase()) ?? [];

        this.mapSetUpOptions = {
            zoom: queryString.get('zoom') ? Number(queryString.get('zoom')) : undefined,
            center_lat: queryString.get('lat') ? Number(queryString.get('lat')) : undefined,
            center_lng: queryString.get('lng') ? Number(queryString.get('lng')) : undefined,
            focusPointId: undefined,
            selectedCategories: categories_array ?? undefined,
            selectedTags: tags_array ?? undefined,
            focusChallengeLocationId: undefined,
        };

        await topicData.instantiateTopicData(
            this.amplitude_callsite,
            accountInfo.isAuthenticated,
            false,
            true
        );
        window.dispatchEvent(new CustomEvent('page-content-ready'));

        // Get the topic and block before getting the points.
        await getMainPage().errorToastElement.tryOrErrorToast(async () => {
            if (isDefined(topicData.topic)) {
                await pointCache.instantiatePointCache(
                    topicData.topic,
                    topicData.topicKey,
                    false,
                    false
                );
            }
        }, 'An error has occurred.  Context: could not get the points from the server.');

        document.documentElement.style.setProperty('--custom-font', topicData.topic?.custom_font ?? 'Montserrat');
        this.style.setProperty('font-family', topicData.topic?.custom_font ?? 'Montserrat');
    }

    render() {
        return html`
            ${topicData.isReady ? html`<map-component
                    hideEmailCapturePopUp
                    hideCategoriesandTags
                    .standaloneMapMode=${true}
                    hidePointCardPaginationOnLoad .focus_load_parameters="${this.mapSetUpOptions}"></map-component> ` : ''}

            <error-toast id="errorToast"></error-toast>
        `;
    }
}
